import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import './WhatWeDo.css'
import Heading from '../../../utls/Heading';

const WhatWeDo = () => {
    return (
        <>
            <div className='container what-we-do'>
                <Heading level={2} className='headings mt-2 text-center'><span>What </span>We Do</Heading>
                <div className='boxContainer  mt-3'>
                <div className='col-lg-6 whatWeDoleft'>
                    <div className='whatweDoBox whatweDoBox1 my-md-2'>
                        <p className=' fw-bold whatweDoBox1Heading'>Corporate Travel</p>
                    </div>
                    <div className='whatweDoBox whatweDoBox2 my-md-2'>
                        <p className=' fw-bold whatweDoBox1Heading'>Destination Management Company</p>
                    </div>
                    <div className='whatweDoBox whatweDoBox3 my-md-2'>
                        <p className='fw-bold whatweDoBox1Heading'>VIP Services</p>
                    </div>
                    <div className='whatweDoBox whatweDoBox4 my-md-2'>
                        <p className='fw-bold whatweDoBox1Heading'>Visa Assistance</p>
                    </div>
                    <div className='whatweDoBox whatweDoBox5 my-md-2'>
                        <p className='fw-bold whatweDoBox1Heading'>Strategic Account Management</p>
                    </div>
                    <div className='whatweDoBox whatweDoBox6 my-md-2'>
                        <p className='fw-bold whatweDoBox1Heading'>University Travel</p>
                    </div>
                </div>
                <div className='col-lg-6 whatWeDoleft'>
                    <div className='whatweDoBox whatweDoBox7 my-md-2'>
                        <p className='fw-bold whatweDoBox1Heading'>Retail & Leisure Travel</p>
                    </div>
                    <div className='whatweDoBox whatweDoBox8 my-md-2'>
                        <p className='fw-bold whatweDoBox1Heading'>Government Travel Management</p>
                    </div>
                    <div className='whatweDoBox whatweDoBox9 my-md-2'>
                        <p className='fw-bold whatweDoBox1Heading'>Travel Insurance</p>
                    </div>
                    <div className='whatweDoBox whatweDoBox10 my-md-2'>
                        <p className='fw-bold whatweDoBox1Heading'>Regional & International Cruise</p>
                    </div>
                    <div className='whatweDoBox whatweDoBox11 my-md-2'>
                        <p className='fw-bold whatweDoBox1Heading'>Small Business Solution Travel</p>
                    </div>
                    <div className='whatweDoBox whatweDoBox12 my-md-2'>
                        <p className='fw-bold whatweDoBox1Heading'>Government Travel</p>
                    </div>
                </div>
                </div>
            </div>
        </>
    )
}

export default WhatWeDo